var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00021 14.8255C5.99631 15.0029 6.04772 15.177 6.14738 15.3238C6.24704 15.4706 6.39002 15.5826 6.55631 15.6444C6.7226 15.7062 6.90399 15.7146 7.0753 15.6686C7.24661 15.6225 7.39923 15.5242 7.51209 15.3873L11.9862 10.1647L16.4587 15.3873C16.5283 15.482 16.6167 15.5613 16.7183 15.6202C16.82 15.6791 16.9327 15.7165 17.0495 15.7298C17.1662 15.7432 17.2845 15.7323 17.3968 15.6978C17.5091 15.6634 17.6132 15.6061 17.7024 15.5296C17.7915 15.453 17.8639 15.3589 17.915 15.2531C17.9661 15.1473 17.9948 15.0321 17.9994 14.9147C18.0039 14.7973 17.9842 14.6802 17.9414 14.5708C17.8986 14.4613 17.8336 14.3619 17.7506 14.2788L12.6346 8.29937C12.5545 8.20547 12.455 8.13007 12.343 8.07837C12.2309 8.02667 12.1089 7.99989 11.9854 7.99989C11.862 7.99989 11.74 8.02666 11.6279 8.07837C11.5158 8.13007 11.4162 8.20547 11.3361 8.29937L6.21521 14.2788C6.08104 14.4298 6.00476 14.6235 6.00001 14.8255L6.00021 14.8255Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow_up.93d94aa37e684c3412317416f9c12d84.svg";
export { ForwardRef as ReactComponent };